exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.projectHeader[data-v-11270166]{min-height:320px\n}\n.projectName[data-v-11270166]{color:white;background:rgba(0,0,0,0.5);display:inline;float:left;font-size:3.5rem !important;padding-top:12px;padding-left:6px;padding-right:6px\n}\n.projectPicture[data-v-11270166]{width:120px;height:120px;max-height:120px;max-width:120px;border:solid 1px white\n}\n.projectDescription[data-v-11270166]{color:#F7F7F7;background-color:rgba(0,0,0,0.5);display:inline-block;font-size:1.1rem !important\n}\n", ""]);

// exports
